/** @jsx h */
import Picture from './Picture';
import Tags from './Tags';
import { searchType } from '../../config';

const TeaserGeneral = ({ result, isMainSearch, showPrio, currentPlz }) => {
  const fallbackImagePath =
    '/_assets/2a3bf18c8dcb388946f7ad7c2f699bb4/Frontend/Build/assets/images/skf_fallback-image.svg';
  function showTags(result) {
    if (
      result.dateFormatted?.length ||
      result.mark?.length ||
      result.dates?.length ||
      result.sessionHours?.length ||
      result.duration?.length ||
      result.typeOfLearning?.length ||
      result.subtitle?.length
    )
      return true;
  }

  const liClasses = function (result) {
    let classesString = 'list-teaser__item click-redirect-parent';

    if (
      result.subtitleInt &&
      result.subtitleInt === 1 &&
      showPrio &&
      result.prio &&
      result.prio === 1
    ) {
      classesString += ' list-teaser__item--highlight';
    }

    return classesString;
  };

  return (
    <li className={liClasses(result)}>
      <article className={isMainSearch ? '' : 'list-teaser__grid'}>
        {!isMainSearch && (
          <div className="list-teaser__image">
            <figure>
              {result.image?.length ? (
                <Picture
                  picture={result.image}
                  alt={result.imageAlt}
                  title={result.imageTitle || result.title}
                  copyright={result.imageCopyright}
                />
              ) : !result.image?.length && searchType === 'news' ? (
                <picture>
                  <img src={fallbackImagePath} alt="" />
                </picture>
              ) : (
                ''
              )}
            </figure>
          </div>
        )}
        <div className="list-teaser__text">
          {showTags(result) ? (
            <Tags
              date={result.dateFormatted}
              datetime={result.datetime}
              categories={result.mark}
              dates={result.dates}
              sessionHours={result.sessionHours}
              duration={result.duration}
              typeOfLearning={result.typeOfLearning}
              subtitle={result.subtitle}
            />
          ) : (
            ''
          )}
          <h3>
            <a
              href={result.url}
              className="click-redirect-target"
              {...(result.urlType === 'external'
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            >
              {result.title}
            </a>
          </h3>
          {result.teaser && (
            <p className="list-teaser__teasertext">{result.teaser}</p>
          )}
          {showPrio && result.prio && result.prio === 1 ? (
            <p className="list-teaser__teasertext">
              Zuständig für PLZ: {currentPlz}
            </p>
          ) : (
            ''
          )}
          <span
            className={`link-${result.urlType} list-teaser__link`}
            data-click-redirect
          >
            <span>{result.urlLabel}</span>
          </span>
        </div>
      </article>
    </li>
  );
};

export default TeaserGeneral;
